import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function stringSerializer(deserializationStrategy) {
  return new (stringSerializer$1())(deserializationStrategy);
}
function stringSerializer$o$_get_descriptor_$ref_wan83j() {
  return constructCallableReference((p0) => p0.b1n(), 1, 0, 18);
}
var stringSerializer$1Class;
function stringSerializer$1() {
  if (stringSerializer$1Class === VOID) {
    class $ {
      constructor($deserializationStrategy) {
        this.t2a_1 = $deserializationStrategy;
        var tmp = this;
        tmp.s2a_1 = lazy(() => $deserializationStrategy.b1n());
      }
      b1n() {
        var tmp0 = this.s2a_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, stringSerializer$o$_get_descriptor_$ref_wan83j(), null);
        return tmp0.n3();
      }
      t1n(encoder, value) {
        return encoder.x1s(toString(value));
      }
      c1n(encoder, value) {
        return this.t1n(encoder, !(value == null) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return this.t2a_1.d1n(decoder);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KSerializer()]);
    stringSerializer$1Class = $;
  }
  return stringSerializer$1Class;
}
//region block: exports
export {
  stringSerializer as stringSerializer3fqetsvttr56r,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
